import moment from 'moment'

export class DateHelper {
  static toIso (date) {
    if (!date) return ''
    return moment(new Date(+date)).toISOString()
  }

  static toTimestamp (date, fmt) {
    // different formats in other places
    // this is a temporary issue for `create fund` page
    // I am a not have a time for check all places where this function is call
    if (typeof (fmt) === 'undefined') {
      fmt = 'YYYY.MM.DD HH:mm:ss'
    }
    return (date ? moment(date).utc().format(fmt) : moment().utc().format(fmt))
  }

  static toUnixTime (date) {
    return '' + (date ? moment(date).utc().format('X') : moment().utc().format('X'))
  }
}



// WEBPACK FOOTER //
// ./src/js/helpers/date.helper.js